export const FieldsFilter = [
  {
    label: 'Busque por campo',
    value: '0',
  },
  {
    label: 'Título',
    value: 'title',
  },
  {
    label: 'Descrição',
    value: 'description',
  },
];

export type ChangeLogHistoryItemValue = {
  field: string;
  status?: string;
  action: 'update' | 'add' | 'delete' | 'archive' | 'activate' | 'deactivate';
  from: string;
  to: string;
};

export type ChangeLogHistoryItem = {
  alias: string;
  values: ChangeLogHistoryItemValue[];
};

export type ChangeLogHistory = {
  field: string;
  status?: string;
  action?: 'update' | 'add' | 'delete' | 'archive' | 'activate' | 'deactivate';
  from?: string;
  to?: string;
  values?: ChangeLogHistoryItem[];
};

export const fieldIsBlock = ['description', 'categories', 'affiliateInstructions', 'affiliateContract', 'programContent'];
export const fieldIsDate = ['launchAt', 'validityAt', 'moderatedAt'];
export const fieldIsCurrency = ['price', 'recurrencePrice', 'recurrenceTaxPrice'];
export const fieldIsHtmlContent = ['programContent'];
export const fieldIsPercentage = [
  'infinityFunnelCommission',
  'commissionValue',
  'recurrenceCommissionValue',
  'commissionPercentual',
  'recruitmentCommission',
];

export const FieldsActionBR = {
  add: 'Adicionou',
  update: 'Editou',
  delete: 'Removeu',
  archive: 'Arquivou',
  activate: 'Ativou',
  deactivate: 'Inativou',
};

export const FieldsNameBR = {
  affiliateInstructions: 'Instruções para afiliados',
  allowAffiliation: 'Permitir venda por afiliado',
  allowAutoAffiliation: 'Afiliação automática',
  allowBankSlip: 'Permitir boleto',
  allowPagDividido: 'Permitir múltiplos cartões',
  allowPix: 'Permitir Pix',
  allowRecurrenceDowngrade: 'Habilitar downgrade de plano',
  allowRecurrenceUpgrade: 'Habilitar upgrade de plano',
  authorName: 'Nome do autor',
  askAddressOnCheckout: 'Endereço no checkout',
  categories: 'Categorias',
  chargeType: 'Tipo de cobrança',
  commissionType: 'Tipo de comissão',
  commissionPercentual: 'Percentual da comissão',
  commissionByAffiliate: 'Comissão por afiliados',
  coproducerIsActive: 'Parceiro ativo',
  coproducerManageAffiliate: 'Gerir afiliados',
  emitNF: 'Emitir NF',
  coproducerCanRefund: 'Reembolsar',
  coproducerViewClientData: 'Ver cliente',
  creditCardTitle: 'Nome exibido na fatura de cartão',
  deliveries: 'Entregas de produto',
  description: 'Descrição do produto',
  hasValidity: 'Validade do produto',
  image: 'Imagem do produto',
  infinityFunnel: 'Funil infinito',
  infinityFunnelCommission: 'Comissão de funil',
  isActive: 'Status do Produto',
  isPreLauch: 'Produto será lançamento',
  launchAt: 'Data do lançamento',
  moderation: 'Moderação',
  moderatedAt: 'Data da moderação',
  price: 'Preço',
  programContent: 'O que contém o seu produto/serviço',
  supportEmail: 'E-mail de suporte',
  recoverySales: 'Recuperar vendas perdidas',
  commissionValue: 'Percentual da comissão de afiliação',
  recurrenceCommissionFirstInvoice: 'Primeira fatura / Taxa de Adesão',
  recurrenceChargeAfterComplete: 'Acesso permanente',
  recurrenceCommissionType: 'Tipo de comissão recorrente',
  recurrenceCommissionValue: 'Percentual da comissão recorrente',
  recurrenceDaysChargeStart: 'Começar a cobrar após',
  recurrenceFrequency: 'Repetir a cada',
  recurrenceFrequencyType: 'Frequência de cobrança',
  recurrenceIsTrial: 'Período trial',
  recurrenceRemoveAccess: 'Remover acesso ao conteúdo',
  recurrenceSendBillingReminder: 'Enviar notificações de renovação',
  recurrenceTaxPrice: 'Valor da adesão',
  recurrenceTrialDays: 'Dias para trial',
  refundAutoApprove: 'Aprovação automática do reembolso',
  sunThankYouPage: 'Url obrigado para boleto',
  title: 'Título do produto',
  isFreeInstallments: 'Parcelamento sem juros',
  unlimitedInstallments: 'Parcelamento sem limites',
  urlCheckout: 'Url obrigado para cartão e PIX',
  validityAt: 'Data de validade',
  visibleOnShowcase: 'Visível na vitrine',
  yearInstallment: 'Habilitar parcelamento no Checkout',
  recurrenceTax: 'Taxa de contratação / adesão',
  recurrencePrice: 'Preço da Assinatura',
  recurrenceChargeEnd: 'A cobrança termina em',
  welcomeEmail: 'Email de acesso da Eduzz',
  coproducers: 'Parceiros',
  thankYouType: 'Parâmetro',
  expectedSales: 'Número de vendas esperadas',
  refundDays: 'Prazo para reembolso',
  allowMultipleCards: 'Permitir múltiplos cartões',
  deliveryAfterFirstPayment: 'Entregar conteúdo apenas na primeira cobrança paga',
  recoveryEmailRecipient: 'Nome do remetente de e-mail para recuperação de vendas',
  inactiveProductUrl: 'Url para o produto inativo',
  askDocumentOnSale: 'Solicitar CPF/CNPJ do pagador',
  askAddressOnSale: 'Solicitar endereço pós compra',
  affiliateContract: 'Contrato de afiliado',
  allowRecruitmentCommission: 'Permitir recrutamento',
  recruitmentCommissionType: 'Tipo de comissão de recrutamento',
  recruitmentCommission: 'Percentual da comissão de recrutamento',
  maxSalesRecruiter: 'Limite de vendas que gerará comissão de recrutamento',
  recurrenceCancelAfterMonths: 'Limite de atraso:',
  allowCreditCard: 'Permitir cartão de crédito',
  file: 'Arquivo',
  url: 'URL',
  hottok: 'Hottok',
  prod: 'Prod',
};
